export default "__VITE_ASSET__B3qZucvu__"